import React from 'react';
import { CheckIcon } from 'lucide-react';
export function WhatIncludes() {
  return <section id="incluye" className="w-full bg-[#0a0a0a] py-20 px-4 sm:px-6 lg:px-8" data-id="element-471">
      <div className="max-w-7xl mx-auto" data-id="element-472">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-473">
          <h2 className="font-heading font-bold text-white uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight" data-id="element-474">
            Lo que incluye tu entrenamiento
          </h2>
          <p className="font-heading text-[#C9A84C] text-xl mt-1 tracking-wide" data-id="element-475">
            (sin pagar extra)
          </p>
          <div className="section-divider" data-id="element-476" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center" data-id="element-477">
          {/* Left: Feature list */}
          <div data-id="element-478">
            <ul className="space-y-4" data-id="element-479">
              <li className="flex items-start gap-4" data-id="element-480">
                <span className="flex-shrink-0 w-6 h-6 rounded bg-[#C9A84C]/15 border border-[#C9A84C]/40 flex items-center justify-center mt-0.5" data-id="element-481">
                  <CheckIcon size={13} className="text-[#C9A84C]" data-id="element-482" />
                </span>
                <span className="font-body text-gray-300 text-base leading-relaxed" data-id="element-483">
                  Entrenamientos guiados por entrenador (técnica + físico)
                </span>
              </li>
              <li className="flex items-start gap-4" data-id="element-484">
                <span className="flex-shrink-0 w-6 h-6 rounded bg-[#C9A84C]/15 border border-[#C9A84C]/40 flex items-center justify-center mt-0.5" data-id="element-485">
                  <CheckIcon size={13} className="text-[#C9A84C]" data-id="element-486" />
                </span>
                <span className="font-body text-gray-300 text-base leading-relaxed" data-id="element-487">
                  Progresión por niveles (para que no te estanques)
                </span>
              </li>
              <li className="flex items-start gap-4" data-id="element-488">
                <span className="flex-shrink-0 w-6 h-6 rounded bg-[#C9A84C]/15 border border-[#C9A84C]/40 flex items-center justify-center mt-0.5" data-id="element-489">
                  <CheckIcon size={13} className="text-[#C9A84C]" data-id="element-490" />
                </span>
                <span className="font-body text-gray-300 text-base leading-relaxed" data-id="element-491">
                  Correcciones personalizadas (no eres "uno más")
                </span>
              </li>

              <li className="flex items-start gap-4" data-id="element-492">
                <span className="flex-shrink-0 w-6 h-6 rounded bg-[#C9A84C]/15 border border-[#C9A84C]/40 flex items-center justify-center mt-0.5" data-id="element-493">
                  <CheckIcon size={13} className="text-[#C9A84C]" data-id="element-494" />
                </span>
                <span className="font-body text-gray-300 text-base leading-relaxed" data-id="element-495">
                  <strong className="text-white" data-id="element-496">
                    Guía de nutrición básica:
                  </strong>{' '}
                  pautas para acompañar tu entrenamiento
                </span>
              </li>
              <li className="flex items-start gap-4" data-id="element-497">
                <span className="flex-shrink-0 w-6 h-6 rounded bg-[#C9A84C]/15 border border-[#C9A84C]/40 flex items-center justify-center mt-0.5" data-id="element-498">
                  <CheckIcon size={13} className="text-[#C9A84C]" data-id="element-499" />
                </span>
                <span className="font-body text-gray-300 text-base leading-relaxed" data-id="element-500">
                  <strong className="text-white" data-id="element-501">
                    Tabla de entrenamientos:
                  </strong>{' '}
                  rutinas complementarias para casa/gym
                </span>
              </li>
              <li className="flex items-start gap-4" data-id="element-502">
                <span className="flex-shrink-0 w-6 h-6 rounded bg-[#C9A84C]/15 border border-[#C9A84C]/40 flex items-center justify-center mt-0.5" data-id="element-503">
                  <CheckIcon size={13} className="text-[#C9A84C]" data-id="element-504" />
                </span>
                <span className="font-body text-gray-300 text-base leading-relaxed" data-id="element-505">
                  Comunidad: compañeros que te empujan a mejorar
                </span>
              </li>
            </ul>

            <p className="font-body text-gray-500 text-sm italic mt-6 border-l-2 border-[#C9A84C]/30 pl-4 leading-relaxed" data-id="element-506">
              La nutrición y la tabla de entrenamientos son un extra de apoyo.
              Si quieres un plan 100% personalizado, se ofrece como servicio
              adicional.
            </p>
          </div>

          {/* Right: Logo card */}
          <div className="flex justify-center lg:justify-end" data-id="element-507">
            <div className="bg-[#1a1a1a] border border-[#C9A84C]/40 p-10 flex flex-col items-center text-center max-w-sm w-full shadow-xl shadow-[#C9A84C]/5" data-id="element-508">
              <img src="https://cdn.magicpatterns.com/uploads/7KGG45Zf29JRX1VVso6grv/karchek.jpg" alt="Kerchak Fighters Team" className="w-36 h-36 rounded-full object-cover border-2 border-[#C9A84C]/50 mb-6 shadow-lg" data-id="element-509" />
              <h3 className="font-heading font-bold text-white uppercase text-2xl tracking-widest mb-2" data-id="element-510">
                Kerchak Fighters Team
              </h3>
              <p className="font-body text-[#C9A84C] text-sm tracking-widest uppercase mb-4" data-id="element-511">
                Boxeo · MMA · K1
              </p>
              <p className="font-body text-gray-400 text-sm leading-relaxed" data-id="element-512">
                Método real. Progresión real. Resultados reales.
              </p>
              <div className="w-12 h-px bg-[#C9A84C]/40 my-4" data-id="element-513" />
              <a href="#precios" className="bg-[#C9A84C] hover:bg-[#E8C97A] text-black font-heading font-bold px-6 py-3 text-sm tracking-widest uppercase transition-all duration-200 w-full text-center" data-id="element-514">
                Reservar Clase
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}